<nav class="navbar navbar-expand-lg navbar-light navbar-main admin w-100">
  <!-- Use any element to open the sidenav -->
  <div class="row mx-0 w-100">
      <div class="col-2 col-lg-1 order-3 order-lg-1 pl-lg-5">
          <button class="navbar-toggle mr-2 border-0 bg-none blue pl-0 pr-1 d-flex d-xl-none justify-content-center align-items-center" [ngClass]="sidebarExpanded ? 'show-button' : 'hide-button' " type="button" id="btn-opn-left-menu" (click)="buttonOpenAndClose()" style="min-height: 40px;">
              <i class="icon-menu_hamb font-size-24"></i>
          </button>
      </div>
      <div class="col-6 col-lg-7 order-1 order-lg-2 d-flex align-items-start px-0">

          <div class="ml-2 text-white d-flex aling-items-center justify-content-center d-lg-none">
              <img src="/assets/img/logo-admin.svg" class="img-responsive" >
              <div class="ml-2 pt-2">
                  <p class="font-size-16 line-height-100 m-0">{{ 'Eficacia' | translate }}</p>
                  <p class="font-size-12 m-0">{{ 'DIY SaaS' | translate }} </p>
              </div>
          </div>
          <div class="row mx-0 d-none d-lg-flex justify-content-center align-items-center">
              <p class="blue-0041A3 font-solomon-semibold font-size-14 w-100 mb-0"><span class="font-size-18 mr-2"><i class="icon-arrow_left font-size-12"></i></span>{{ 'Regresar a la sección previa' | translate }}</p>
              <p class="blue-dark font-solomon font-size-12 breadcrumb-header w-100 mb-0">inicio > {{ 'nombre sección padre' | translate }} > <span class="actual green-3BD4AE">{{ 'Nombre sección actual' | translate }}</span></p>
            </div>
      </div>
      <div class="col-4 order-2 order-lg-3 pr-0">
          <img src="/assets/img/avatar_header.png"  class="ml-3 img-responsive header-avatar float-right d-block d-lg-none">
          <div class="align-items-center justify-content-end d-none d-lg-flex">

              <div class="header-search mr-5 pr-4 d-flex justify-content-center align-items-center">
                  <i class="icon-search font-size-18 gray-C4C7CE mr-4"></i> <i class="icon-notification gray-C4C7CE font-size-20 mr-2"></i>
              </div>

              <p class="font-size-14 font-solomon-semibold mb-0">Andrés Gómez</p>
              <img src="/assets/img/avatar_header.png"  class="ml-3 img-responsive header-avatar">

          </div>
      </div>
  </div>



  <button class="navbar-toggler mr-3 d-none" type="button" data-toggle="collapse" data-target="#navbarNavDropdown" aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
    <span class="navbar-toggler-icon"></span>
  </button>

  <div class="collapse navbar-collapse bg-white" id="navbarNavDropdown">


  </div>
</nav>
